import React, { useState, useEffect } from 'react';
import DeviceCheckDefault from './DeviceCheckDefault';
import { adminApi, api } from '../services/api'; // Import the api service
// Import DeviceCheckZoom if needed later
// import DeviceCheckZoom from './DeviceCheckZoom';

// Check the video provider from environment variables
const isZoomEnabled = () => {
  const VIDEO_PROVIDER = process.env.REACT_APP_VIDEO_PROVIDER || 'default';
  return VIDEO_PROVIDER === 'zoom';
};

/**
 * DeviceCheck component that handles device check and provides options for phone visit or support
 * if video check fails.
 *
 * @param {Object} props - Component props
 * @param {Function} props.onSuccess - Callback function to call when device check is successful
 * @returns {JSX.Element} The appropriate device check component or failure options
 */
const DeviceCheck = ({ onSuccess, onFailure, tokenData }) => { // Added tokenData prop
  const [videoCheckFailed, setVideoCheckFailed] = useState(false);
  const [videoCheckSucceeded, setVideoCheckSucceeded] = useState(false);


  // Timer for video check timeout (10 seconds)
  useEffect(() => {
    const timer = setTimeout(() => {
      // If onSuccess hasn't been called after 30 seconds and videoCheckSucceeded is false, set videoCheckFailed to true
      if (!videoCheckSucceeded) {
        setVideoCheckFailed(true);
        if (onFailure) { // Call onFailure callback if provided
          onFailure();
        }
      }
    }, 10000); // 10 seconds

    // Clear the timer if the component unmounts or if video check succeeds
    return () => clearTimeout(timer);
  }, [videoCheckSucceeded]); // Rerun effect if videoCheckSucceeded changes

  // Modify onSuccess to set videoCheckSucceeded to true
  const handleSuccess = () => {
    setVideoCheckSucceeded(true);
    onSuccess(); // Call the original onSuccess prop
  };


  // Determine which device check component to use based on video provider
  const useZoom = isZoomEnabled();


  // Render the appropriate device check component
  if (videoCheckFailed) {
    // When timeout occurs, show DeviceCheckDefault with forceError=true
    // This will trigger the error UI in DeviceCheckDefault
    return <DeviceCheckDefault
      onSuccess={handleSuccess}
      forceError={true}
      tokenData={tokenData}
      caseId={tokenData?.case_id}
    />;
  }

  // PART 2b: Render Default device check when REACT_APP_VIDEO_PROVIDER is not zoom
  // Or render DeviceCheckZoom if useZoom is true
  return useZoom ? (
    // TODO: Implement DeviceCheckZoom component
    // <DeviceCheckZoom onSuccess={handleSuccess} /> // Use the modified success handler
    <p>Zoom device check not yet implemented.</p> // Placeholder
  ) : (
    <DeviceCheckDefault
      onSuccess={handleSuccess}
      onFailure={() => setVideoCheckFailed(true)}
      tokenData={tokenData}
      caseId={tokenData?.case_id}
    /> // Pass both success and failure handlers
  );
};

export default DeviceCheck;